@if (form) {
	<form [formGroup]="form">
		@if (type === OffersType.DAYTRIP) {
			<p class="u-title-sub">{{ 'BOOKING.INFO.DAYTRIP.TITLE' | translate }}</p>
			<p class="u-text--grey-blue u-m-bottom--sm" [innerHTML]="'BOOKING.INFO.DAYTRIP.DESCRIPTION' | translate"></p>

			<div class="u-row">
				<tvcore-datepicker class="u-col-sm--12 u-col--3" [label]="'BOOKING.INFO.DAYTRIP.ARRIVAL_DATE' | translate" name="arrivalDate" icon="date" [showErrors]="showErrors">
					<tvcore-input-error name="required">{{ 'FORM.ERROR.REQUIRED' | translate }}</tvcore-input-error>
					<tvcore-input-error name="dateAfter">{{ 'BOOKING.INFO.DATE_AFTER_TODAY_ERROR' | translate }}</tvcore-input-error>
				</tvcore-datepicker>

				<tvcore-dropdown
					class="u-col-sm--12 u-col--3"
					[label]="'BOOKING.INFO.DAYTRIP.ARRIVAL_HOUR' | translate"
					name="arrivalHour"
					[options]="hourOptions"
					[showErrors]="showErrors"
				>
					<ng-template #optionTemplate let-option>{{ option }}</ng-template>
				</tvcore-dropdown>
			</div>
		} @else if (type === OffersType.ACCOMMODATION) {
			<p class="u-title-sub">{{ 'BOOKING.INFO.ACCOMMODATION.TITLE' | translate }}</p>
			<p class="u-text--grey-blue u-m-bottom--sm" [innerHTML]="'BOOKING.INFO.ACCOMMODATION.DESCRIPTION' | translate"></p>

			<div class="u-row">
				<tvcore-datepicker class="u-col-sm--12 u-col--3" [label]="'BOOKING.INFO.ACCOMMODATION.ARRIVAL_DATE' | translate" name="arrivalDate" icon="date" [showErrors]="showErrors">
					<tvcore-input-error name="required">{{ 'FORM.ERROR.REQUIRED' | translate }}</tvcore-input-error>
					<tvcore-input-error name="dateAfter">{{ 'BOOKING.INFO.DATE_AFTER_TODAY_ERROR' | translate }}</tvcore-input-error>
				</tvcore-datepicker>

				<tvcore-datepicker
					class="u-col-sm--12 u-col--3"
					[label]="'BOOKING.INFO.ACCOMMODATION.DEPARTURE_DATE' | translate"
					name="departureDate"
					icon="date"
					[showErrors]="showErrors"
				>
					<tvcore-input-error name="required">{{ 'FORM.ERROR.REQUIRED' | translate }}</tvcore-input-error>
					<tvcore-input-error name="dateAfter">{{ 'BOOKING.INFO.DATE_AFTER_TODAY_ERROR' | translate }}</tvcore-input-error>
					<tvcore-input-error name="after">{{ 'BOOKING.INFO.DATE_AFTER_ARRIVAL_ERROR' | translate }}</tvcore-input-error>
				</tvcore-datepicker>
			</div>

			<div class="u-row">
				<tvcore-dropdown
					class="u-col-sm--12 u-col--3"
					[label]="'BOOKING.INFO.ACCOMMODATION.ARRIVAL_HOUR' | translate"
					name="arrivalHour"
					[options]="hourOptions"
					[showErrors]="showErrors"
				>
					<ng-template #optionTemplate let-option>{{ option }}</ng-template>
				</tvcore-dropdown>
			</div>
		}

		<p class="u-title-sub u-m-top--md u-m-bottom--sm">{{ 'BOOKING.INFO.EXTRA_INFO_TITLE' | translate }}</p>

		<div class="u-row">
			<div class="u-col--12">
				<p class="u-text--medium">
					{{ 'BOOKING.INFO.EXTRA_INFO_LABEL' | translate }}
					<span class="u-text--sm u-text--grey-blue u-text--normal">(optioneel)</span>
				</p>
				<p class="u-text--grey-blue">
					@if (type === OffersType.DAYTRIP) {
						{{ 'BOOKING.INFO.EXTRA_INFO_DESCRIPTION_DAYTRIP' | translate }}
					} @else if (type === OffersType.ACCOMMODATION) {
						{{ 'BOOKING.INFO.EXTRA_INFO_DESCRIPTION_ACCOMMODATION' | translate }}
					}
				</p>
				<tvcore-input name="extraInfo" type="textarea" [maxChar]="MAX_CHARS_INFO" [showErrors]="showErrors"></tvcore-input>
			</div>
		</div>

		<div class="u-m-top--sm u-m-bottom--sm">
			<tvcore-checkbox class="u-width--md" name="confirmSocial" [showErrors]="showErrors">
				<span [innerHTML]="'BOOKING.INFO.CONFIRM_SOCIAL' | translate"></span>
			</tvcore-checkbox>
			<p *ngIf="confirmSocialError" class="u-text--error u-text--sm">{{ 'FORM.ERROR.REQUIRED' | translate }}</p>
		</div>

		<div class="u-m-bottom--sm">
			<tvcore-checkbox class="u-width--md" name="confirmStandard" [showErrors]="showErrors">
				@if (type === OffersType.DAYTRIP) {
					{{ 'BOOKING.INFO.CONFIRM_STANDARD_DAYTRIP' | translate }}
				} @else if (type === OffersType.ACCOMMODATION) {
					{{ 'BOOKING.INFO.CONFIRM_STANDARD_ACCOMMODATION' | translate }}
				}
			</tvcore-checkbox>
			<p *ngIf="confirmStandardError" class="u-text--error u-text--sm">{{ 'FORM.ERROR.REQUIRED' | translate }}</p>
		</div>
	</form>
}
